import React from "react";
import CTA from "./CTA";
import Me from "../../assets/me3.webp";
import HeaderSocials from "./HeaderSocials";
import "./header.scss";

const Header: React.FC = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm </h5>
        <h1>Milad Ranjbar</h1>
        <h5 className="text-light">I build things for the web</h5>

        <CTA />

        <div className="me">
          <div className="me-image-wrapper">
            <img src={Me} alt="milad ranjbar" />
          </div>
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>

        <HeaderSocials />
      </div>
    </header>
  );
};

export default Header;
